<template>
  <FlotoForm @submit="handleSubmit">
    <MCol :size="12">
      <MRow :gutter="0">
        <MCol>
          <FormConsumer
            v-if="customFieldsForAll.length"
            :disabled="disabled"
            :value="asset.fieldValueDetails"
            :form-fields="customFieldsForAll"
            :avoid-default-value="Boolean(asset.id)"
            :with-submit="false"
            :focus-event-brodcast="false"
            @change="handleFieldValueChange"
          />
          <MDivider v-if="customFieldsForAll.length > 0" />
        </MCol>
      </MRow>
      <div v-if="assetTypeId">
        <div
          v-for="assetTypeField in selectedAssetTypes.list"
          :key="assetTypeField.id"
        >
          <template
            v-if="(customFieldForAssetType[assetTypeField.id] || []).length"
          >
            <div class="mx-2 text-primary md-text-base my-2">
              {{ assetTypeField.name }}
            </div>
            <FormConsumer
              :value="asset.fieldValueDetails"
              :disabled="disabled"
              :form-fields="customFieldForAssetType[assetTypeField.id]"
              :avoid-default-value="Boolean(asset.id)"
              :with-submit="false"
              :focus-event-brodcast="false"
              @change="handleFieldValueChange"
            />
            <MDivider dashed />
          </template>
        </div>
      </div>
    </MCol>
    <template v-slot:submit>
      <MCol :size="12">
        <div class="flex justify-end">
          <MButton v-if="!disabled" :loading="internalProcessing" type="submit">
            {{ $t('update') }}
          </MButton>
        </div>
      </MCol>
    </template>
  </FlotoForm>
</template>

<script>
import FormConsumer from '@components/form-consumer.vue'
export default {
  name: 'CustomFieldTab',
  components: { FormConsumer },
  props: {
    customFieldsForAll: { type: Array, required: true },
    selectedAssetTypes: { type: Object, required: true },
    customFieldForAssetType: { type: Object, required: true },
    assetTypeId: { type: Number, required: true },
    asset: { type: Object, required: true },
    updateApi: { type: Function, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      internalProcessing: false,
    }
  },
  methods: {
    handleFieldValueChange(c) {
      this.$emit('change', c)
    },
    handleSubmit() {
      this.internalProcessing = true
      const requestData = this.asset.fieldValueDetails
      this.updateApi(requestData)
        .then(() => {
          this.$nextTick(() => {
            this.internalProcessing = false
          })
        })
        .catch(() => {
          this.$nextTick(() => {
            this.internalProcessing = false
          })
        })
    },
  },
}
</script>
